import React, { useRef, useEffect } from 'react';
import { useOutlet, useLocation } from 'react-router-dom';
import { useTabStore } from '../store/tabStore';

const KeepAliveOutlet: React.FC = () => {
  const location = useLocation();
  const outlet = useOutlet();
  const cacheRef = useRef<Map<string, React.ReactElement>>(new Map());
  const tabs = useTabStore((s) => s.tabs);

  const cacheKey = location.pathname + location.search;

  if (outlet) {
    cacheRef.current.set(cacheKey, outlet);
  }

  // Remove cached pages whose tabs have been closed
  useEffect(() => {
    const tabPaths = new Set(tabs.map((t) => t.path));
    Array.from(cacheRef.current.keys()).forEach((key) => {
      if (!tabPaths.has(key)) cacheRef.current.delete(key);
    });
  }, [tabs]);

  return (
    <>
      {Array.from(cacheRef.current.entries()).map(([key, element]) => (
        <div
          key={key}
          data-active={key === cacheKey ? 'true' : undefined}
          style={{ display: key === cacheKey ? 'flex' : 'none', flex: 1, flexDirection: 'column', minHeight: 0 }}
        >
          {element}
        </div>
      ))}
    </>
  );
};

export default KeepAliveOutlet;
